import { useQuery } from '@tanstack/react-query';
import type { WidgetApiResponse } from 'abi-lcm-common-types';

import { lcmApi } from '~/shared/services/api';

export const GET_WIDGET_NOT_SUBMITTED_NOMINATIONS_QUERY_KEY =
  'homeV2/useGetWidgetNotSubmitted';

async function getWidgetNotSubmittedNominations(): Promise<WidgetApiResponse> {
  const { data } = await lcmApi.get<WidgetApiResponse>(
    '/widgets/not-submitted-nomination'
  );

  return data;
}

export function useGetWidgetNotSubmittedNominations() {
  return useQuery({
    queryKey: [GET_WIDGET_NOT_SUBMITTED_NOMINATIONS_QUERY_KEY],
    queryFn: getWidgetNotSubmittedNominations,
  });
}
